import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from "antd";

const OtherDetailTab = () => {

const dataSource = [
{
key: "", // Add a unique key for each row
SNo: "", // Changed to camelCase

},
]

return (
<>
    <div className="row border-bottom-2 card m-1">
        <div className="col-md-12 card-body">

              <div className="row mt-2"> 
              <div className="col-md-6">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                            Volume
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0 d-flex gap-1">
                        <input type="number" className="form-control form-control-sm w-50" />
                        <Select className='custom-selector w-50 ' name="role_id" placeholder='CBM' />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className=' '>
                        <label htmlFor="" className='form-label  mb-0'>
                            Tonnage
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0 d-flex gap-1">
                        <input type="number" className="form-control form-control-sm w-50" />
                        <Select className='custom-selector w-50 ' name="role_id" placeholder='Kgs' />
                        </div>
                    </div>
                </div>
             

            </div> 

            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
               
               
            </div>
        </div>
    </div>

</>
);
};

export default OtherDetailTab